
import HeaderTail from './src/HeaderTail.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        HeaderTail
    }
})

export default class TumsHeader extends Vue {
    logoPic = '/wlanPlanner/static/img/logo.png';
};
